import {
    CHAT_USER, ACTIVE_CHAT_POSITION, FULL_DIALOG, ADD_LOGGED_USER, CREATE_GROUP, TEXT_MESSAGE, MUTED,
    ONLINE_USERS,
    ACTIVE_CHAT_ID, UPDATE_MESSAGES,
    RELOAD_CHATS,
    FILTER_CHATS,
    UPDATE_LAST_MESSAGES
} from './constants';


export const chatUser = () => ({
    type: CHAT_USER
});

export const setActiveChatPosition = (position) => ({
    type: ACTIVE_CHAT_POSITION,
    payload : position
});

export const setUpdateMessages = (updateMessages) => ({
    type: UPDATE_MESSAGES,
    payload : updateMessages
});

export const setUpdateLastMessages = (updateLastMessages) => ({
    type: UPDATE_LAST_MESSAGES,
    payload : updateLastMessages
});

export const setActiveChatId = (activeChatId) => ({
    type: ACTIVE_CHAT_ID,
    payload : activeChatId
});

export const setTextMessage = (textMessage) => ({
    type: TEXT_MESSAGE,
    payload: textMessage
});

export const setFullDialog = (fullDialog) => ({
    type: FULL_DIALOG,
    payload : fullDialog
});

export const setOnlineUsers = (onlineUsers) => ({
    type: ONLINE_USERS,
    payload : onlineUsers
});

export const addLoggedinUser = (userData) => ({
    type: ADD_LOGGED_USER,
    payload : userData
});

export const setMuted = (muted) => ({
    type: MUTED,
    payload: muted
});

export const createGroup = (groupData) => ({
    type : CREATE_GROUP,
    payload : groupData
});

export const setReloadChats = (reloadChats) => ({
    type: RELOAD_CHATS,
    payload : reloadChats
});

export const setFilterChats = (filterChats) => ({
    type: FILTER_CHATS,
    payload : filterChats
});
